import React from 'react';
import { useLocale } from 'locale';
import AdditionalIcon from 'assets/svg/filters.svg';
import { ControlButton } from 'ds/components/button';
import { DeveloperFiltersState } from 'store/state/app';
import Downshift  from 'downshift';
import { FiltersInner } from './FiltersInner';
import { FilterPopupContainer } from 'components/filters/styled/dropdown';
import * as Styled from './styled';
import { FiltersControls } from './FiltersControls';


interface ProjectFiltersDropdownProps {
  filters: DeveloperFiltersState;
  activeFilters: number;
  setFilters: (filters: DeveloperFiltersState) => void;
  onSubmit: () => void;
  onClear: () => void;
  onClose: () => void;
}

export const ProjectFiltersDropdown: React.FC<ProjectFiltersDropdownProps> = (props) => {
  const { filters, activeFilters, setFilters, onSubmit, onClear, onClose } = props;
  const { t } = useLocale();

  return (
    <div>
      <Downshift
        onOuterClick={onClose}
      >
        {({ isOpen, getLabelProps, toggleMenu, closeMenu }) => (
          <div>
            <ControlButton
              {...getLabelProps()}
              onClick={toggleMenu}
              mode={isOpen || activeFilters ? 'selected' : 'default'}
            >
              <AdditionalIcon />
              <span>{t('developerPage.navigation.filter', { count: activeFilters })}</span>
            </ControlButton>
            {isOpen ? (
              <Styled.DropdownSection>
                <FilterPopupContainer data-auto="filters-container">
                  <Styled.InnerContainer withOutPadding={false}>
                    <FiltersInner filters={filters} setFilters={setFilters} />
                  </Styled.InnerContainer>
                  <FiltersControls onClear={onClear} onSubmit={onSubmit} onClose={closeMenu} />
                </FilterPopupContainer>
              </Styled.DropdownSection>
            ) : null}
          </div>
        )}
      </Downshift>
    </div>
  );
};

export default React.memo(ProjectFiltersDropdown);
